import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Category, CategoryModel } from "@/apidtos";

interface CatalogContentProps {
  category?: Category | CategoryModel | null;
}

const CatalogHeaderContent = ({ category }: CatalogContentProps) => {
  if (!category?.Content?.HeaderContent) {
    return null;
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: category.Content.HeaderContent }} />
  );
};

const CatalogDescriptionContent = ({ category }: CatalogContentProps) => {
  if (!category?.Content?.DescriptionContent) {
    return null;
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: category.Content.DescriptionContent }} />
  );
};

const CatalogSidebarContent = ({ category }: CatalogContentProps) => {
  if (!category?.Content?.SidebarContent) {
    return null;
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: category.Content.SidebarContent }} />
  );
};

registerExtension("Catalog.HeaderContent", CatalogHeaderContent, "CatalogHeaderContent");
registerExtension("Catalog.DescriptionContent", CatalogDescriptionContent, "CatalogDescriptionContent");
registerExtension("Catalog.SidebarContent", CatalogSidebarContent, "CatalogSidebarContent");
